"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmFieldTemplate = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const SmFieldTemplate = (_a) => {
    var { id, label, message, invalid, disabled, type = 'text', srOnly, className } = _a, props = __rest(_a, ["id", "label", "message", "invalid", "disabled", "type", "srOnly", "className"]);
    const containerClassname = (0, classnames_1.default)({
        '-invalid': invalid,
        '-disabled': disabled,
    }, 'c-field', className);
    const controlClassname = (0, classnames_1.default)('c-control', `-${type}`);
    return (react_1.default.createElement("div", { className: containerClassname },
        !srOnly && (react_1.default.createElement("label", { className: "c-field__label", htmlFor: id }, label)),
        react_1.default.createElement("div", { className: controlClassname }, props.children),
        message && (react_1.default.createElement("small", { id: `${id}-description`, className: "c-field__description" },
            invalid && !disabled && (react_1.default.createElement(Icon_1.SmIcon, { type: "outlined", name: "error_outline", size: "small", className: "mr-2" })),
            message))));
};
exports.SmFieldTemplate = SmFieldTemplate;
//# sourceMappingURL=field.js.map